import http from '@homeservices/api-kit/axios';

const NATIONAL_ZIPCODES = '78660,90650,92592,30339';
const DEV_NATIONAL_ZIPCODES = '92243,33612,30339';
const isDev = process.env.NODE_ENV !== 'production';

export default {
  namespaced: true,
  state () {
    return {
      nationalTrendingServices: null,
      trendingServices: null,
    };
  },
  getters: {
    nationalTrendingServices (state) {
      return state.nationalTrendingServices;
    },
    trendingServices (state) {
      return state.trendingServices;
    },
  },
  actions: {
    async fetchNationalTrendingServices ({ commit }) {
      const zipcodes = isDev ? DEV_NATIONAL_ZIPCODES : NATIONAL_ZIPCODES;
      const { data: { results } } = await http.get(`/platform/workorder/r/workorder/service-aggregations/popular-services/v1?zipcodes=${zipcodes}&days=120&size=3&is_pro_referral_org=true`);
      commit('setNationalTrendingServices', results);
    },
    async fetchTrendingServices ({ commit }, zipcode) {
      const { data: { results } } = await http.get(`/platform/workorder/r/workorder/service-aggregations/popular-services/v1?zipcodes=${zipcode}&days=120&size=3&is_pro_referral_org=true`);
      commit('setTrendingServices', results);
    },
  },
  mutations: {
    setNationalTrendingServices (state, data) {
      state.nationalTrendingServices = data;
    },
    setTrendingServices (state, data) {
      state.trendingServices = data;
    },
  },
};
